<template>
<div>
    <div class="innerBox">
            <div class="mb-4 row">
                <div class="col-md-5"></div>
                <div class="col-md-2">
                    <h3 
                        class="tableTitle text-left"
                        style="font: normal normal normal 16px/25px Poppins;">User Question</h3>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2 text-right">
                    <button
                        class="btn rounded w-100"
                        type="button"
                        style="background-color: #CFECF9; font: normal normal normal 12px/18px Poppins;"
                        @click="modal.tambah = true"
                    >Tambah</button>
                </div>
            </div>

            <!-- Table Start -->
            <vue-universal-table
                api_url="/api/settings/question/list"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                :buttons="vue_universal_table.buttons"
                :infinite_scroll="true"

                sort_order="ASC"
                sort_by="created_at"
                style="font: normal normal normal 12px/18px Poppins;"

                @onEditDetails="openEditDetails"
                @onDelete="deleteQuestion"
            />
            <!-- Table End -->
        </div>

        <UserQuestionTambah 
            v-if="modal.tambah" 
            @refreshTable="vue_universal_table.update++" 
            @closeModal="modal.tambah = false" 
        />

        <UserQuestionUpdate
            v-if="modal.edit"
            :data="modal.data"
            @refreshTable="vue_universal_table.update++"
            @closeModal="modal.edit = false; modal.data = null" 
        />
</div>  
</template>

<script>
import UserQuestionTambah from './children/UserQuestionTambah.vue';
import UserQuestionUpdate from './children/UserQuestionUpdate.vue';
export default {
    metaInfo : {
        title: 'User Question'
    },
    data() {
        return {
            modal : {
                data: null,
                tambah: false,
                edit: false
            },
            vue_universal_table: {
                fields: [
                    {title: 'Nama Pertanyaan', variable: 'name', disable_sort: true},
                    {title: 'Jawaban Benar', variable: 'answer_true', disable_sort: true},
                    {title: 'Jawaban Salah', variable: 'answer_false', disable_sort: true},
                    {title: 'Point', variable: 'point'},
                    {title: 'Photo ?', variable: 'is_photo', disable_sort: true},
                    {title: 'Last Created', variable: 'formatted_created_at'}
                ],
                buttons: [
                    {title: 'editDetails', class: 'fas fa-pen btn-outline-primary'},
                    {title:"Delete", variable:"id", class:"fas fa-trash btn-outline-danger"},
                ],
                update: 0
            }
        }
    },
    methods: {
        openEditDetails (data) {
            this.modal.data = JSON.parse(data);
            this.modal.edit = true;
        },
        deleteQuestion (id) {
            this.$swal.fire({
                    title: 'Apakah Anda yakin?',
                    text: "data yang telah dihapus tidak dapat dikembalikan lagi",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085D6',
                    cancelButtonColor: '#D33',
                    confirmButtonText: 'Delete'
                }).then((result) => {
                    if (result.value) {
                        this.$swal({
                            title: 'Loading....'
                        })
                        this.$swal.showLoading();
                        this.$http.delete(`/api/settings/question/delete/${id}`)
                        .then(()=>{
                            this.$swal.close();
                            this.$swal.fire({
                                title : "Success!",
                                icon : "success",
                                type : "success",
                                text : `User Question telah dihapus`
                            })
                            this.vue_universal_table.update++;
                        })
                        .catch((error)=>{
                            console.log('%cerror UserQuestion.vue line:78 ', 'color: red; display: block; width: 100%;', error);
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                type : "error",
                                text : error.response.data.message
                            })
                        })
                    }
                })
        }
    },
    components: {
        UserQuestionTambah,
        UserQuestionUpdate
    }
}
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>